export default "__VITE_ASSET__D85wGAa7__ 480w, __VITE_ASSET__gFyg4$9m__ 768w, __VITE_ASSET__VGBj7pgt__ 1200w, __VITE_ASSET__B3DQRMQt__ 1600w";